export default __webpack_public_path__ + "static/media/528hz-deep-meditation.69684f72.jpg";